/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanyProfileV3StatusEnum = 'Created' | 'WaitingForActivation' | 'Active' | 'WaitingForDeactivation' | 'Deactivated' | 'WaitingForReactivation' | 'Expired' | 'WaitingForPublication';

export const CompanyProfileV3StatusEnum = {
    Created: 'Created' as CompanyProfileV3StatusEnum,
    WaitingForActivation: 'WaitingForActivation' as CompanyProfileV3StatusEnum,
    Active: 'Active' as CompanyProfileV3StatusEnum,
    WaitingForDeactivation: 'WaitingForDeactivation' as CompanyProfileV3StatusEnum,
    Deactivated: 'Deactivated' as CompanyProfileV3StatusEnum,
    WaitingForReactivation: 'WaitingForReactivation' as CompanyProfileV3StatusEnum,
    Expired: 'Expired' as CompanyProfileV3StatusEnum,
    WaitingForPublication: 'WaitingForPublication' as CompanyProfileV3StatusEnum
};

